import { useMutation } from "@apollo/client";

import {
  ChangeRecurringDepositMutation,
  ChangeRecurringDepositMutationVariables,
  TransactionTime,
} from "@ctypes";
import { TRANSACTIONS, UPDATE_SIP, USER } from "@graphql";
import { DEFAULT_SIZE } from "@hooks/transfers";

export const useUpdateSip = () => {
  return useMutation<ChangeRecurringDepositMutation, ChangeRecurringDepositMutationVariables>(
    UPDATE_SIP,
    {
      refetchQueries: [
        USER,
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Upcoming,
          },
        },
      ],
      awaitRefetchQueries: true,
    },
  );
};
